// extracted by mini-css-extract-plugin
module.exports = {"btns":"ActionsEditDelete_btns__1YwU6","editBtn":"ActionsEditDelete_editBtn__2ezVV","deleteBtn":"ActionsEditDelete_deleteBtn__3QvHm"};